export default __webpack_public_path__ + "static/media/kucoin.3dd79802.png";